import { Configuration, LogLevel } from '@azure/msal-browser';

export const API_SCOPE = 'api://55a9e41f-149c-4e9e-a2a6-4afb6a2e9bed/access_as_user';

/**
 * MSAL Configuration for Azure AD Authentication
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: '55a9e41f-149c-4e9e-a2a6-4afb6a2e9bed',
    authority: 'https://login.microsoftonline.com/cb66ec92-c88f-4855-9424-4bdb17863c2e',
    redirectUri: typeof window !== 'undefined' ? window.location.origin : '',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
        }
      },
      logLevel: LogLevel.Info,
      piiLoggingEnabled: false,
    },
  },
};
